import { useEffect, useState } from "react";
import {
  NotificationsNone as NotificationsNoneIcon,
  Mail as MailIcon,
} from "@mui/icons-material";
import { Toolbar, ListItemIcon, MenuItem, Grid } from "@mui/material";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CryptoJS from "crypto-js";
import { useMediaQuery } from "react-responsive";
import Cookies from "js-cookie";

import server from "../functions/server";
import { useDashboardData } from "../hooks/useDashboardData";
import { useRefresh } from "../hooks/useRefresh";
import Copyright from "./components/Copyright";
import AppDrawer from "./components/dashboard/AppDrawer";
import AppHeader from "./components/dashboard/AppHeader";
import PageContent from "./components/dashboard/PageContent";

import ChatBot from "./components/ChatBot";

export default function DashboardContent() {
  const isLandscape = useMediaQuery({ query: "(orientation: landscape)" });
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const { handleRefreshUser } = useRefresh();

  let nome = localStorage.getItem("nomeparc");
  let user = localStorage.getItem("user");
  const changepass = localStorage.getItem("changepass");

  try {
    if (nome && user) {
      nome = CryptoJS.AES.decrypt(nome, "MedSys@341");
      nome = CryptoJS.enc.Utf8.stringify(nome);

      user = CryptoJS.AES.decrypt(user, "MedSys@341");
      user = CryptoJS.enc.Utf8.stringify(user);
    }
  } catch {
    localStorage.removeItem("nomeparc");
    window.location.href = "/portal";
  }

  const {
    isPuxando,
    isPuxandoPed,
    isPuxandoEq,
    isPuxandoCad,
    dadosTitulo,
    fetchData,
    dadosPedidos,
    dadosEquip,
    dadosCad,
  } = useDashboardData(user);

  const [open, setOpen] = useState(isLandscape);
  const [openDialog, setOpenDialog] = useState(changepass === "S");
  const [mode, setMode] = useState(localStorage.getItem("mode") || "light");
  const [abaTit, setAbaTit] = useState("1");
  const [abaPed, setAbaped] = useState("1");
  const [pagina, setPagina] = useState(8);
  const [notificacoes, setNotificacoes] = useState("");
  const [novaNotific, setNovaNotific] = useState(false);

  useEffect(() => {
    if (isPuxando === 0) {
      fetchData();
    }
  }, [fetchData, isPuxando]);

  useEffect(() => {
    localStorage.setItem("mode", mode);
  }, [mode]);

  useEffect(() => {
    if (!notificacoes && user) {
      setNotificacoes(true); 
      
      const options = {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: "Bearer " + Cookies.get("bearer"),
        },
        body: new URLSearchParams({
          jsonid: localStorage.getItem("token"),
          cgc_cpf: user,
        }),
      };

      fetch(`${server}portalCliente/consulta/notificacoes`, options)
        .then((response) => response.text())
        .then(function (respq) {
          const resposta = JSON.parse(respq);

          if (!resposta.data) {
            localStorage.removeItem("nomeparc");
            window.location.href = "/portal";
            return;
          }

          let conteudo = (
            <>
              {resposta.data[0] ? (
                resposta.data.map((unico, index) => {
                  setNovaNotific(true); 
                  return (
                    <MenuItem key={index} onClick={() => setPagina(unico[2])}>
                      <ListItemIcon>
                        <MailIcon />
                      </ListItemIcon>
                      {unico[0]}
                    </MenuItem>
                  );
                })
              ) : (
                <MenuItem>
                  <ListItemIcon>
                    <NotificationsNoneIcon />
                  </ListItemIcon>
                  Sem nenhuma notificação
                </MenuItem>
              )}
            </>
          );

          setNotificacoes(conteudo);
        });
    }
  }, [notificacoes, user]);

  useEffect(() => {
    const interval = setInterval(() => {
      handleRefreshUser();
    }, 5 * 60 * 1000);

    return () => clearInterval(interval);
  }, [handleRefreshUser]);

  if (!nome) {
    localStorage.removeItem("nomeparc");
    window.location.href = "/portal";
    return null; 
  }

  const handlePagina = (numpagina) => setPagina(numpagina);
  const handleAbaTit = (event, novaAba) => setAbaTit(novaAba);
  const toggleDrawer = () => setOpen(!open);
  const openModal = () => setOpenDialog(true);

  const mdTheme = createTheme({
    palette: { mode },
  });

  return (
    <ThemeProvider theme={mdTheme}>
      <div style={{ position: "relative", zIndex: 9999 }}>
        <ChatBot />
      </div>

      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <AppHeader
          open={open}
          toggleDrawer={toggleDrawer}
          mode={mode}
          modeShift={() => setMode(mode === "light" ? "dark" : "light")}
          notificacoes={notificacoes}
          novaNotific={novaNotific}
          setNovaNotific={setNovaNotific}
          nome={nome}
        />
        <AppDrawer
          open={open}
          toggleDrawer={toggleDrawer}
          onPageChange={handlePagina}
          isMobile={isMobile}
          openModal={openModal}
        />
        <Box
          component="main"
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode === "light"
                ? theme.palette.grey[100]
                : theme.palette.grey[900],
            flexGrow: 1,
            height: "100vh",
            overflow: "auto",
            padding: { xs: 1, sm: 1, md: 3 },
            paddingTop: { xs: 3 },
            paddingBottom: { xs: 3 },
          }}
        >
          <Toolbar />

          <Grid container spacing={3}>
            <Grid item xs={12}>
              <PageContent
                pagina={pagina}
                isPuxando={isPuxando}
                isPuxandoPed={isPuxandoPed}
                isPuxandoEq={isPuxandoEq}
                isPuxandoCad={isPuxandoCad}
                dadosTitulo={dadosTitulo}
                dadosPedidos={dadosPedidos}
                dadosEquip={dadosEquip}
                dadosCad={dadosCad}
                nome={nome}
                user={user}
                abaTit={abaTit}
                abaPed="1"
                handleAbaTit={handleAbaTit}
                setPagina={setPagina}
              />
            </Grid>
          </Grid>
          <Copyright sx={{ pt: 4, mt: 3 }} />
        </Box>
      </Box>
    </ThemeProvider>
  );
}